import { Navigate, Route, Routes } from 'react-router-dom';

import { MenuInfo } from 'data';
import { Error404 } from 'pages';
import { MonitoringReportDataroomLayout } from 'layout/monitoring';
import MonitoringReportDataroomTabsRoutes from './MonitoringReportDataroomTabsRoutes';

export default function MonitoringReportDataroomRoutes() {
    const report_dataroom = MenuInfo.CMMS_REPORT_DATAROOM;
    return (
        <Routes>
            <Route path="/*" element={ <MonitoringReportDataroomLayout/> }>
                <Route path="/*" element={ <Navigate to={report_dataroom.children[0].path}/> }/>
                {
                    report_dataroom.children.map(child => {
                        return (
                            <Route key={child.id} path={child.path + '/*'} element={ <MonitoringReportDataroomTabsRoutes menuId={child.id}/> }/>
                        );
                    }) 
                }
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}